<template>
    <div>
        <div v-if="filtersReady">
            <div class="row pl-3">
                <div class="col-md-12 sammio-categories__selection">
                    <h4 class="sammio-panels__title pb-0">{{ $t('sammio.show') }}</h4>
                    <div class="row">
                        <v-checkbox
                                v-model="activeTypeFilters"
                                :label="getFilterLabel(filters.type.act)"
                                @change="refreshData"
                                :value="filters.type.act.categoryId"
                                :multiple=true
                                :class="'col-12 ' + (isMobile ? 'col-sm-4 px-3' : 'col-xl-4 px-0')"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="activeTypeFilters"
                                :label="getFilterLabel(filters.type.decree)"
                                @change="refreshData"
                                :value="filters.type.decree.categoryId"
                                :multiple=true
                                :class="'col-12 ' + (isMobile ? 'col-sm-4 px-3' : 'col-xl-4 px-0')"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="activeTypeFilters"
                                :label="getFilterLabel(filters.type.regulation)"
                                @change="refreshData"
                                :value="filters.type.regulation.categoryId"
                                :multiple=true
                                :class="'col-12 ' + (isMobile ? 'col-sm-4 px-3' : 'col-xl-4 px-0')"
                        >
                        </v-checkbox>
                    </div>
                </div>

                <div class="col-md-12 sammio-categories__selection" v-if="isMobile">
                    <h4 class="sammio-panels__title pb-0">{{ $t('sammio.target_fields') }}</h4>
                    <div class="row">
                        <v-checkbox
                                v-model="activeCardFieldFilters"
                                :label="$t('sammio.' + filters.cardField.subsection.label)"
                                @change="refreshData"
                                :value="filters.cardField.subsection.value"
                                :multiple=true
                                :class="'col-12 ' + (isMobile ? 'col-sm-4 px-3' : 'col-xl-4 px-0')"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="activeCardFieldFilters"
                                :label="$t('sammio.' + filters.cardField.justification.label)"
                                @change="refreshData"
                                :value="filters.cardField.justification.value"
                                :multiple=true
                                :class="'col-12 ' + (isMobile ? 'col-sm-4 px-3' : 'col-xl-4 px-0')"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="activeCardFieldFilters"
                                :label="$t('sammio.' + filters.cardField.guidance.label)"
                                @change="refreshData"
                                :value="filters.cardField.guidance.value"
                                :multiple=true
                                :class="'col-12 ' + (isMobile ? 'col-sm-4 px-3' : 'col-xl-4 px-0')"
                        >
                        </v-checkbox>

                    </div>
                </div>

            </div>

            <div class="mt-4">
                <h4 class="sammio-panels__title pl-3">{{ $t('sammio.filter_results') }}</h4>

                <div class="sammio-theme--radiation" >
                    <h5  id="headlineRadiation" class="sammio-panels__title--category " :data-title="filters.categories[0].title">
                        {{filters.categories[0].description ? filters.categories[0].description : filters.categories[0].title}}
                    </h5>

                    <sammio-treeview
                        :items="filters.categories[0].children"
                        item-label="label"
                        item-key="categoryId"
                        @input="refreshData()"
                        :active="activeRadiationCategoryFilters"
                        v-model="activeRadiationCategoryFilters"
                        labelledby="headlineRadiation"
                        describedby="searchFilterDescription"
                        :selected="openRadiationCategoryFilters"
                        :identifier="convertText(filters.categories[0].title)"
                    ></sammio-treeview>

                </div>

                <div class="sammio-theme--content">
                  <h5 id="headlineContentCategory" class="sammio-panels__title--category" :data-title="filters.categories[1].title">
                    {{filters.categories[1].description ? filters.categories[1].description : filters.categories[1].title}}
                  </h5>
                  <sammio-treeview
                      :items="filters.categories[1].children"
                      item-label="label"
                      item-key="categoryId"
                      @input="refreshData()"
                      v-model="activeContentCategoryFilters"
                      :active="activeContentCategoryFilters"
                      labelledby="headlineContentCategory"
                      describedby="searchFilterDescription"
                      :selected="openContentCategoryFilters"
                      :identifier="convertText(filters.categories[1].title)"
                  ></sammio-treeview>
                </div>
                <div id="searchFilterDescription" class="d-none">
                  {{ $t('sammio.search_filters.tip')}}
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {i18n} from "../../translations/i18n";
    import SammioTreeview from "@/components/SammioTreeview";
    import { mapGetters } from 'vuex'

    export default {
        name: "SammioSearchFilters",
        components: {
          SammioTreeview
        },
        data() {
            return {
                openRadiationCategoryFilters: [],
                openContentCategoryFilters: [],
                currentLocale: i18n.locale,
                parentCategoryIds: new Map(),
                childCategoryIds: new Map()
            }
        },
        computed: {
            ...mapGetters({
                filtersReady: 'getFiltersReady',
                filters: 'getFilters',
                activeFilters: 'getActiveFilters',
                isMobile: 'getIsMobile'
            }),
            activeTypeFilters: {
                set(categoryIds) {
                    this.$store.dispatch('updateActiveTypes', categoryIds)
                },
                get() {
                    return this.activeFilters.types
                }
            },
            activeCardFieldFilters: {
                set(cardFields) {
                    this.$store.dispatch('updateActiveCardFields', cardFields)
                },
                get() {
                    return this.activeFilters.cardFields
                }
            },
            activeRadiationCategoryFilters: {
                set(newCategoryIds) {
                    newCategoryIds = this.getNewCategoryIds(newCategoryIds, 0)

                    let activeCategories = [newCategoryIds, this.activeContentCategoryFilters]
                    this.$store.dispatch('updateActiveCategories', activeCategories)
                },
                get() {
                    let filters = this.activeFilters.categories[0]
                    if (!filters) {
                        filters = []
                    }
                    return filters
                }
            },
            activeContentCategoryFilters: {
                set(newCategoryIds) {
                    newCategoryIds = this.getNewCategoryIds(newCategoryIds, 1)

                    const activeCategories = [this.activeRadiationCategoryFilters, newCategoryIds]
                    this.$store.dispatch('updateActiveCategories', activeCategories)
                },
                get() {
                    let filters = this.activeFilters.categories[1]
                    if (!filters) {
                        filters = []
                    }
                    return filters
                }
            },

            locale() {
                return i18n.locale
            }
        },
        watch: {
            filtersReady() {
                this.$store.dispatch('fetchCards')
                this.$store.dispatch('updateActiveCategories', [[],[]])
                for (let rootCategory of this.filters.categories) {
                    for (let parentCategory of rootCategory.children) {
                        let childCategoryIds = []
                        for (let childCategory of parentCategory.children) {
                            this.parentCategoryIds.set(childCategory.categoryId, parentCategory.categoryId)
                            childCategoryIds.push(childCategory.categoryId)
                        }
                        this.childCategoryIds.set(parentCategory.categoryId, childCategoryIds)
                    }
                }
            },
            locale(lang) {
                if (this.$router.currentRoute.name.startsWith('search')) {
                    this.$store.dispatch('initFilters')
                    this.$store.dispatch('fetchCards')

                }
            },
            $route(to, from) {
                if (to.name.startsWith('search') && this.currentLocale !== i18n.locale) {
                    this.$store.dispatch('initFilters')
                    this.$store.dispatch('fetchCards')
                }
            }
        },
        methods: {
            getFilterLabel(filter) {
                return this.$t(filter.label); // + ' (' + filter.count + ')'
            },
            refreshData() {
                this.$store.dispatch('fetchCards')
                this.$store.dispatch('setSearchCurrentPage', {page: 1})
            },
            getArrayDiff(array1, array2) {
                // note: returns only the first differing element, which is enough here
                const array2Set = new Set(array2);
                const diffArray = [...new Set(array1.filter(x => !array2Set.has(x)))];

                let diff = 0
                if (diffArray.length > 0) {
                    diff = diffArray[0]
                }
                return diff
            },
            getNewCategoryIds(newCategoryIds, index) {
                // handles the logic when parent category is selected/deselected
                const rootCategory = this.activeFilters.categories[index]
                if (rootCategory) {
                    const oldCategoryIds = rootCategory.flat(3)
                    const addedCategoryId = this.getArrayDiff(newCategoryIds, oldCategoryIds)
                    let removedCategoryId = 0

                    if (addedCategoryId !== 0) {
                        // if parent is added and none of the children yet selected -> add all children
                        const isParent = this.childCategoryIds.has(addedCategoryId)
                        if (isParent) {
                            const children = this.childCategoryIds.get(addedCategoryId)
                            let childAlreadySelected = false
                            for (let childCategoryId of children) {
                                if (newCategoryIds.includes(childCategoryId)) {
                                    childAlreadySelected = true
                                    break
                                }
                            }
                            /* YJAYSS-249 disable action that adds children even they are not selected
                            if (!childAlreadySelected) {
                              newCategoryIds.push(...children)
                            }
                            */

                        }
                    } else {
                        removedCategoryId = this.getArrayDiff(oldCategoryIds, newCategoryIds)
                        // if parent is removed
                        //   if all children are selected -> remove all children but retain parent as selected
                        //   else if some or none of the children is selected -> remove parent from selected
                        if (removedCategoryId !== 0) {
                            const isParent = this.childCategoryIds.has(removedCategoryId)
                            if (isParent) {
                                const children = this.childCategoryIds.get(removedCategoryId)
                                let allChildrenSelected = children.length > 0
                                for (let childCategoryId of children) {
                                    if (!newCategoryIds.includes(childCategoryId)) {
                                        allChildrenSelected = false
                                        break
                                    }
                                }
                                if (allChildrenSelected) {
                                    newCategoryIds.push(removedCategoryId)
                                    newCategoryIds = newCategoryIds.filter(catId => !children.includes(catId))
                                }
                            }

                        }
                    }

                }
                return newCategoryIds
            },
            convertText(str) {
              const text = str
                  .toLowerCase()
                  .replace("ä","a")
                  .replace("ö","o")
                  .replace("/[^A-Za-z0-9\\-]/","_")
                  .replace("/-+/g","_");
              return text;
            }
        }
    }
</script>

<style lang="scss">
    .v-input--selection-controls__input {
        position: relative;
        display: inline-block;
        margin-right: 0.5rem;

        svg { vertical-align: sub; }
        input[type="checkbox"] {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            left: 0;
            top: 0;
        }
    }

    .v-treeview-node {
        // fix treeview buttons on FF and Safari
        [type="button"] {
            -webkit-appearance: none;
        }

    }
</style>
